import { TSpaceResponseData } from 'typings';
import { homeSecurityPortalApi } from 'data/axios';
import { ApiResponse } from './HttpRequest';
import { endpoints } from './endpoints';

export async function GetAllSpaces(): Promise<
  ApiResponse<TSpaceResponseData[]>
> {
  const response = await homeSecurityPortalApi.get(endpoints.getAllSpaces, {
    headers: {
      'Accept-Version': 'v2'
    }
  });
  console.log('GetAllSpaces', response);
  return response;
}
